import React, { useState, useEffect, useRef } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import TextStyle from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import { parse } from '@leverege/expression-parser';
import classnames from 'classnames';
import S from './ExpressionEditor.css';
import Underline from './tiptapPlugins/Underline.js';
import TokenizerFactory from './tokenizers/Factory.js';
import TokenStylizerFactory from './tokenStylizers/Factory.js';

// define your extension array
const extensions = [TextStyle, Color, Document, Paragraph, Text, Underline.extension];
function ExpressionEditor(props) {
  const {
    onChange,
    stylizerSettings = {
      type: 'TokenStylizer.basic'
    },
    value,
    className
  } = props;
  const init = useRef(false);
  const updating = useRef(false);
  const cParse = async ({
    editor
  }) => {
    const before = editor.getText();
    let parsed;
    try {
      parsed = await parse(before, {
        includeAstInfo: true,
        allowInvalidObjects: true
      });
    } catch (err) {
      // ignore
      console.log(err);
    }
    return parsed;
  };
  const stylize = ({
    editor,
    parsed
  }) => {
    if (parsed) {
      const tokens = TokenizerFactory.create(parsed);
      const stylizer = TokenStylizerFactory.create(stylizerSettings, {
        editor
      });
      stylizer?.run(tokens);
    }
    return {
      parsed
    };
  };
  const onUpdate = ({
    editor
  }) => {
    if (!init.current || updating.current) {
      return;
    }
    updating.current = true;
    const editorValue = editor.getText();
    cParse({
      editor
    }).then(parsed => {
      onChange?.({
        value: editorValue,
        parsed
      });
      stylize({
        editor,
        parsed
      });
      updating.current = false;
    });
  };
  const onCreate = ({
    editor
  }) => {
    cParse({
      editor
    }).then(parsed => {
      const editorValue = editor.getText();
      onChange?.({
        value: editorValue,
        parsed
      });
      stylize({
        editor,
        parsed
      });
      init.current = true;
    });
  };
  const editor = useEditor({
    extensions,
    content: value,
    parseOptions: {
      preserveWhitespace: 'full'
    },
    onUpdate,
    onCreate
  });
  const editorValue = editor.getText();
  // TODO: this feels janky
  useEffect(() => {
    if (value !== editorValue && !updating.current) {
      editor.commands.setContent(value, true);
    }
  }, [value, editorValue]);
  return /*#__PURE__*/React.createElement(EditorContent, {
    spellCheck: false,
    className: classnames(S.editor, className),
    editor: editor
  });
}
export default ExpressionEditor;